<template>
  <div class="bdgWrp">
    <!--<div class="sigboxItem clear">
      <el-checkbox style="float:right;margin-right:0" v-model="checked" @change="operate">Tick Activated Labour</el-checkbox>
    </div>-->
    <div class="deputy">
      <el-table
          :data="tableData"
          border
          style="width: 100%">
        <el-table-column
          prop="dateDisplay"
          label="WEEK ENDING">
        </el-table-column>
        <el-table-column
          prop="hours"
          label="HOURS">
        </el-table-column>
        <el-table-column
          prop="salaried"
          label="SALARIED">
        </el-table-column>
        <el-table-column
          prop="casual"
          label="CASUAL">
        </el-table-column>
        <el-table-column
          prop="cost"
          label="COST">
          <template slot-scope="scope">
            ${{formatDecimal2(scope.row.cost, 2)}}
          </template>
        </el-table-column>
        <el-table-column
          label="OPERATION">
          <template slot-scope="scope">
            <button @click="dtl(scope.row.date)">Details</button>
          </template>
        </el-table-column>
        <template slot="empty">
          <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
          <div v-else>-</div>
        </template>
      </el-table>
      <pageination :total="totalRecord" :size="pagesize" @togglePage="pageChange"></pageination>
    </div>
  </div>
</template>

<script>
import api from '../../../api/account'
import pageination from '../../../components/common/pageination'

export default {
  data () {
    return {
      loading: true,
      tableData: [],
      page: 1,
      pagesize: 10,
      totalRecord: 0,
      checked:false
    }
  },
  created () {
    if (!this.$route.params.id) {
      return
    }
    api.weekdeputyRoster({
      params: {
        pageNum: this.page,
        pageSize: this.pagesize,
        venueId: parseInt(this.$route.params.id)
      },
      callback: this.callback
    })
  },
  methods: {
    // 2021/01/30
    operate () {
      if (this.checked === true) {
        this.$box.loadings()
        api.activatedLabour({
          params: {
            tickActivatedLabour: 1,
            venueId: this.$route.params.id
          },
          callback: (res) => {
            this.$box.loadings(2)
            if (res.data.code === 0) {
              //
            } else{
              this.checked = false
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
      } else {
        this.$box.loadings()
        api.activatedLabour({
          params: {
            tickActivatedLabour: 0,
            venueId: this.$route.params.id
          },
          callback: (res) => {
            this.$box.loadings(2)
            if (res.data.code === 0) {
              //
            } else{
              this.checked = true
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
      }
    },

    dtl (time) {
      this.$router.push(`/detail/deputy/${this.$route.params.id}/${time}`)
    },
    callback (res) {
      var that = this
      that.loading = false
      if(res.data.code == 0){
        res.data.data.list.forEach(item => {
          item.dateDisplay = this.$box.getDateFormat(item.date * 1000, 'DD-MMM-yyyy')
          item.fmtdate = that.$box.formatDateMonthyear3(item.date)
          item.hours = this.$box.formatDecimal2(item.hours, 2)
          item.salaried = this.$box.formatDecimal2(item.salaried, 2)
          item.casual = this.$box.formatDecimal2(item.casual, 2)
        })
        that.tableData = res.data.data.list
        that.totalRecord = res.data.data.total
        that.checked = res.data.data.metadata === 0 ? false : true
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    pageChange (page) {
      this.page = page
      this.tableData = []
      this.loading = true
      api.deputyRoster({
        params: {
          pageNum: this.page,
          pageSize: this.pagesize,
          venueId: parseInt(this.$route.params.id)
        },
        callback: this.callback
      })
    },
    // 小数截断
    formatDecimal(num, decimal) {
      if (num === null){
        return null
    }
      if (num == 0) {
        return '0.00'
      }
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
        num = num.substring(0, decimal + index + 1)
      } else {
        num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
    formatDecimal2 (s, type) {
      if (s== 0) {
        return "0.00";
      }
      if (!s) {
        return null
      }
      if (s == null || s == "") {
        return '';
      }
      if (JSON.stringify(s).indexOf('.') === -1) {
        type = 0
      }
      s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      if (type == 0) {// 不带小数位(默认是有小数位)
        var a = s.split(".");
        if (a[1] == "00") {
          s = a[0];
        }
      }
      if (s.indexOf('.') === -1)
        s = s + '.00'
      return s;
},
  },
  components: {
    pageination
  }
}
</script>

<style lang="scss" scoped>
.bdgWrp{
  width: 100%;
  margin-bottom: 30px;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
  min-width: 880px;
  .sigboxItem{
    margin-bottom: 22px;
  }
  .deputy{
    min-width: 820px;
    button{
      width:100px;
      outline: none;
      height:40px;
      background:rgba(21,28,39,1);
      border:1px solid rgba(234,55,150,1);
      font-size:18px;
      font-family:'PingFangSC-Semibold';
      font-weight:600;
      color:rgba(234,55,150,1);
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/DeRoster/week.vue